<div class="container-fluid" (keydown)="onKeydown($event)">
  <div class="row">
    <div class="col-md-4 "></div>
    <div class="col-sm-12 col-md-4">
      <div class="container-login" style="width: 100%; margin-top: 50px; text-align: center">
        <div class="imagen-login-container">
          <img class="imagen-login" src="../../../assets/img/captarmedia-login.png">
        </div>
        <div class="form-login">
          <ngb-alert [type]="alertType" *ngIf="successMessage" (close)="successMessage = null">
            <h5>{{ successMessage }}</h5>
          </ngb-alert>
          <hr />
          <form [formGroup]="form" (ngSubmit)="recuperar()">
            <input formControlName="email" type="email" class="input-login" placeholder="Ingrese su email">
            <div *ngIf="form.get('email').touched && form.get('email').invalid" class="text-danger small">
              <span *ngIf="form.get('email').errors?.required">El email es requerido</span>
              <span *ngIf="form.get('email').errors?.email">Ingrese un email válido</span>
            </div>
            <div style="margin-top: 8px;"><a routerLink="/recuperar-codigo" class="link-login"
                style="font-size:13px;">¿Eres administrador? Recuperar con código</a></div>

            <div class="row container-button">
              <button type="submit" class="button-login" [disabled]="pending">ENVIAR LINK</button>
            </div>
          </form>
          <div style="display: flex; justify-content: center;">
            <button class="link-login "style="border: 0; background: none;" (click)="irALogin()">Volver al inicio de sesión</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/recuperar/recuperar.component.html